/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('.owl-carousel-home').on('initialized.owl.carousel changed.owl.carousel', function(e) {
          if (!e.namespace)  {
            return;
          }
          var carousel = e.relatedTarget;

          $('.banner-counter').text(carousel.relative(carousel.current())  + 1 +  ' / ' + carousel.items().length);
          }).owlCarousel({
            slideSpeed: 300,
            paginationSpeed: 4000,
            navigation: true,
            singleItem: true,
            mouseDrag: false,
            touchDrag: false,
            animateOut: 'fadeOut',
            autoplay: false,
            dots: true,
            nav: true,
            loop:true,
            items:1
        });
        $('.carousel-we-work').on('initialized.owl.carousel changed.owl.carousel', function(e) {
          if (!e.namespace)  {
            return;
          }
          var carousel = e.relatedTarget;
          $('.slider-counter').text(carousel.relative(carousel.current())  + 1 +  ' / ' + carousel.items().length);
          }).owlCarousel({
            slideSpeed: 5000,
            paginationSpeed: 5000,
            autoplaySpeed: 5000,
            navigation: true,
            singleItem: true,
            mouseDrag: false,
            touchDrag: false,
            animateOut: 'fadeOut',
            autoplay: false,
            dots: true,
            nav: true,
            loop:true,
            items:1
        });
        $('.carousel-partner').owlCarousel({
            autoplay: true,
            dots: true,
            nav: false,
            loop:true,
            items:6,
            responsive:{
              0:{

                items:2,
                nav: false,
                navText: "",
                margin: 20,
              },
              568:{

                items:3,
                nav: false,
                navText: "",
                margin: 25,
              },
              768:{

                items:3,
                nav: false,
                navText: "",
                margin: 30,
              },
              1024:{

                items:6,
                nav: false,
                navText: "",
              }
            }
        });
        
        var url = window.location.href.replace(/\/$/, '');
        var urlSlug = url.substring(url.lastIndexOf('/') + 1);
        $(function() {

          $('.top-nav li a#nav-' + urlSlug ).parent().addClass('active');
        });
        $("video#vid").load().trigger('play');
        $(".item .content-video video#vid").load().trigger('play');

      
        if (/Edge\/\d./i.test(navigator.userAgent)){
           var vid = $('.gallery .gall-box .content-video video');
           console.log(vid);
           vid.css('transform','scale(1.98)');
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);



})(jQuery); // Fully reference jQuery after this point.
